

<form class="form-horizontal" #form="ngForm">
  <label class="control-label col-sm-3" >
    {{ 'Provider' | translate }}:
  </label>
  <div class="col-sm-9" >
  <select  [(ngModel)]="Provider_new" name="provider_new" class="form-control">
    <option [ngValue]="null">---</option>
    <option
        *ngFor="let provider_ of providers_"
        [ngValue]="provider_">
        <!-- {{provider_.name | translate}} -->
        {{ provider_?.provider_site?.name }}
        -
        <span *ngIf="provider_?.coverage?.coverage_type == 1">
          {{ 'Plane' | translate }} {{ provider_?.coverage?.plane }}
        </span>
        <span *ngIf="provider_?.coverage?.coverage_type == 2">
          {{ 'Foreign'  | translate }}
        </span>
    </option>
  </select>
    <br>
  </div>

  <div class="form-group">
    <div class="col-sm-offset-3 col-sm-9 div-btn-right">
      <button (click)="Generar()" class="btn btn-primary btn-sm btn-right"  >
        {{ 'Save' | translate }}
     </button>
   
      
    </div>
</div>

</form>
